export default function Messages(){return <div><h1 className="text-2xl font-black">Messages</h1><p className="mt-2 text-slate-600">Notification center.</p></div>;}
